import { sendEvent } from '@core/analytics'

type THoldFailureStage =
    | 'create_setup'
    | 'confirm_setup'
    | 'preauth_check'
    | 'element_error'
    | 'unexpected_error'

export const sendHoldFailedEvent = (stage: THoldFailureStage) =>
    sendEvent({
        name: 'checkout_hold_failed',
        payload: { params__key: ['preauth_check'], params__str_value: [stage] },
    })
